<template>
  <div>
    <div class="banner">
      <el-image :src="banner.url"/>
    </div>
    <!--盈利分析  -->
    <el-image :src="images[0].url" alt="盈利分析"/>
    <!-- 8大加盟支持 -->
    <el-image id="jmzc" :src="images[1].url" alt="加盟支持"/>
    <!-- 加盟优势 -->
    <el-image id="jmys" :src="images[6].url" alt="加盟优势"/>
    <el-image :src="images[2].url" alt="加盟条件"/>
    <el-image :src="images[3].url" alt="加盟流程"/>
    <!-- 加盟电话 -->
    <el-image :src="images[4].url" alt="加盟电话"/>
    <el-image :src="images[5].url" alt="加盟理由"/>
  </div>
</template>

<script>
import { StationsMixins } from '../../mixins/StationsMixins'

export default {
  name: 'CommercialPage',
  mixins: [StationsMixins],
  data () {
    return {
      banner: { url: require('../../assets/images/commercial/banner.jpg') },
      images: [
        { url: require('../../assets/images/commercial/old/18.jpg') },
        { url: require('../../assets/images/commercial/old/16.jpg') },
        { url: require('../../assets/images/commercial/old/12.jpg') },
        { url: require('../../assets/images/commercial/old/13.jpg') },
        { url: require('../../assets/images/commercial/old/22.jpg') },
        { url: require('../../assets/images/commercial/old/10.jpg') },
        { url: require('../../assets/images/commercial/old/19.jpg') }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/style.css";
@import "../../assets/css/reset.css";
@import "../../assets/css/media.css";

.el-divider {
  margin-bottom: 80px;
}

.lmtit {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  text-align: center;
}

.el-image {
  margin: 0;
}

.lmxian {
  height: 1px;
  width: 60px;
  background: #287ab6;
  margin: 0 auto;
}

.nr {
  .pic {
    max-height: 166px;
  }
}
</style>
